import { colors, VStack } from "goi_common";
import { ReactNode } from "react";

interface Props {
  title: ReactNode;
  pageName: string;
  description?: string;
  color?: string;
}

const RegistrationTitleSection = ({
  title,
  pageName,
  description,
  color,
}: Props) => {
  return (
    <section>
      <span
        className="subtitle_14_b"
        style={{ color: color ? color : colors.orange650 }}
      >
        {pageName}
      </span>
      <VStack gap="1px">
        <h1 css={{ whiteSpace: "pre-line" }} className="head_28_b gray900">
          {title}
        </h1>
        {description && (
          <p
            css={{
              whiteSpace: "break-spaces",
            }}
            className="body_14_m gray900"
          >
            {description}
          </p>
        )}
      </VStack>
    </section>
  );
};

export default RegistrationTitleSection;
